/**
 * Scrolls root element to target element position.
 *
 * @param id - target element id
 * @param rootElementId - scroll container
 */
export const scrollToElementId = (id, rootElementId = undefined) => {

    if (id !== null && id !== undefined) {

        const element = document.getElementById(id);
        if (element) {
            const y = element.getBoundingClientRect().top + window.scrollY;

            const root = rootElementId ? document.getElementById(rootElementId) || window : window;
            root.scroll({top: y, behavior: 'smooth'});
        }
        else {
            console.warn('[scrollToElementId] Element not found by id:', id);
        }
    }
}

export const scrollToTop = () => {
    window.scroll({top: 0, behavior: 'smooth'});
}
